export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
// export const KEY = '<YOUR KEY>';
export const KEY = 'e4518149-40af-455e-b202-cc39f0ea7c59';
export const MODAL_CLOSE_SEC = 2.5;
